export * from './PermissionDetail';
